<template>
	<div>
		<b-tabs content-class="mt-3">
			<b-tab title="Mapa de Calor" >
				<MapToolQuotes></MapToolQuotes>
			</b-tab>
			<b-tab title="Resumen" active>
				<ListToolQuotes></ListToolQuotes>
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
import api from "../../../../api.js";
import MapToolQuotes from "../../../helpers/QuotesInMap.vue"
import ListToolQuotes from "../../../helpers/QuotesInList.vue"
export default {
	name: "comercial",
	components: {MapToolQuotes,ListToolQuotes},
	data() {
		return {

		};
	},
	methods: {
		search() {

		},
		excel() {
			this.loadingExport = true;
			api(this)
				.get(`/reports/${this.codeReport}`, {
					params: {
						filters: this.filters,
						format: "excel"
					},
					responseType: "blob"
				})
				.then(res => {
					this.$root.downloadExcel(res, "adicionales");
				})
				.catch(error => {
					this.$root.handleRequestError(error);
				})
				.finally(() => {
					this.loadingExport = false;
				});
		}
	},
	mounted() {

	},
	computed: {

	}
};
</script>
